import { render, staticRenderFns } from "./form-component-select-person-in-role.vue?vue&type=template&id=a4c4e506"
import script from "./form-component-select-person-in-role.vue?vue&type=script&lang=ts"
export * from "./form-component-select-person-in-role.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports